import { useEffect } from "react";

/**
 * Lightweight SEO hook — sets <title>, meta description, canonical and OG tags
 * on mount and restores defaults on unmount. Avoids the React-Helmet bundle weight.
 */
export default function useSeo({ title, description, path, image }) {
  useEffect(() => {
    const prev = {
      title: document.title,
      desc: document.querySelector('meta[name="description"]')?.getAttribute("content"),
      ogTitle: document.querySelector('meta[property="og:title"]')?.getAttribute("content"),
      ogDesc: document.querySelector('meta[property="og:description"]')?.getAttribute("content"),
      ogUrl: document.querySelector('meta[property="og:url"]')?.getAttribute("content"),
      canonical: document.querySelector('link[rel="canonical"]')?.getAttribute("href"),
    };

    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      if (!value) return;
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    if (path) setMeta('meta[property="og:url"]', "content", `https://emakurer.dk${path}`);
    if (path) {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.setAttribute("href", `https://emakurer.dk${path}`);
    }
    if (image) setMeta('meta[property="og:image"]', "content", image);

    return () => {
      if (prev.title) document.title = prev.title;
      setMeta('meta[name="description"]', "content", prev.desc);
      setMeta('meta[property="og:title"]', "content", prev.ogTitle);
      setMeta('meta[property="og:description"]', "content", prev.ogDesc);
      setMeta('meta[property="og:url"]', "content", prev.ogUrl);
      if (prev.canonical) {
        const c = document.querySelector('link[rel="canonical"]');
        if (c) c.setAttribute("href", prev.canonical);
      }
    };
  }, [title, description, path, image]);
}
